
import { delMyRevise } from '@/api/profile'
import { ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'upper-under',
  props: {
    biosBnCommentBoList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['requestData'],
  setup(_, { emit }) {
    const { t } = useI18n()
    const radio = ref('-1' as string)
    const checked = ref(true as boolean)
    const packVisible = ref(0)
    const open = (key: number) => {
      packVisible.value = key
    }
    const packUp = () => {
      packVisible.value = -1
    }
    const delReviseOpinion = (val) => {
      const Url = require('@/common/image/profile/profile-delete.svg')
      ElMessageBox.confirm(
        `<img class='del-logo' src="${Url}" /><p class='del-msg'>${t(
          'profile.deleteMsg'
        )}</p><p class='del-msg-one'>${t('profile.deleteMsgOne')}</p>`,
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: `${t('profile.delete')}`,
          cancelButtonText: `${t('profile.deleteCancel')}`,
          center: true,
        }
      )
        .then(async () => {
          const result = await delMyRevise(
            val.version,
            val.cid,
            2,
            val.timestamp
          )
          if (result && result.code === 0) {
            emit('requestData')
            ElMessage({
              type: 'success',
              message: result.msg,
            })
          } else {
            ElMessage({
              type: 'error',
              message: result.msg,
            })
          }
        })
        .catch(() => {})
    }
    return {
      radio,
      checked,
      packVisible,
      open,
      packUp,
      delReviseOpinion,
    }
  },
})
